import React, { useEffect, useState } from "react";
import { Col, DatePicker, Pagination } from "antd";
import "../../assets/css/search-filter.css";
import { useDispatch, useSelector } from "react-redux";
import { listEmployers } from "../../features/employer/employerSlice";
import EmployerTable from "../../components/table/EmployerTable";
import dayjs from 'dayjs';
import { useSearchParams } from "react-router-dom";
import EmployerFilter from "../../components/filter/EmployerFilter";
import { isMobile } from "../../utils/Utils";
import EmployerCard from "../../components/card/EmployerCard";

export default function ManageEmployer() {
  const { employers } = useSelector((state) => state.employer);
  const [searchParams, setSearchParams] = useSearchParams();
  const [profession, setProfession] = useState("Professions");
  const [status, setStatus] = useState("Status");
  const [val, setVal] = useState("Search");
  const [privateEmployer, setPrivateEmployer] = useState("All Employers");
  const { RangePicker } = DatePicker;
  const dispatch = useDispatch();

  const detectMobile = isMobile();

  // fetch employers
  const fetchEmployers = () => {
    if (!searchParams.get("page")) {
      searchParams.set("page", 1);
    }
    if (!searchParams.get("limit")) {
      searchParams.set("limit", 10);
    }

    if (searchParams.get("search")) {
      dispatch(listEmployers(encodeURI(searchParams.get("search")) + "?" + searchParams.toString()));
    } else {
      dispatch(listEmployers("?" + searchParams.toString()));
    }

  };

  // handle date change
  const handleDateChange = (dates) => {
    if (!(!dates || !dates[0] || !dates[1])) {
      let startDate = dayjs(dates[0].$d).format("MM-DD-YYYY");
      let endDate = dayjs(dates[1].$d).format("MM-DD-YYYY");
      searchParams.set("StartDate", startDate);
      searchParams.set("EndDate", endDate);
      setSearchParams(searchParams);
    }
    else {
      searchParams.delete("StartDate");
      searchParams.delete("EndDate");
      setSearchParams(searchParams);
    }
  };

  // handle pagination per page
  const onShowSizeChange = (current, pageSize) => {
    searchParams.set("page", current);
    searchParams.set("limit", pageSize);
    setSearchParams(searchParams);
  };

  // handle pagination page
  const handleChange = (page, pageSize) => {
    searchParams.set("page", page);
    searchParams.set("limit", pageSize);
    setSearchParams(searchParams);
    window.scrollTo(0, 0);
  };

  // For applied filters
  useEffect(() => {
    fetchEmployers();
    if(!searchParams.get("Professioncode")){
      setProfession("Professions");      
    }    
    if(!searchParams.get("Status")){
      setStatus("Status");
    }    
    if(!searchParams.get("search")){
      setVal("search");
    }
    if(!searchParams.get("private")){
      setPrivateEmployer("All Employers");
    }    
  }, [searchParams]);

  return (
    <div className="ManageEmployerContainer">
      <div className="rcdFilterContainer">
        <div className="dateRangePickerContainer">
          <div className="userTypeText">Manage Employer</div>
          {!detectMobile && <div className="dateRangePickerBox">
            <span className="default90days">
              {/* {isDateChange ? "" : "Last 30 days"} */}
            </span>
            <RangePicker
              suffixIcon={false}
              className="dateRangePicker"
              onChange={handleDateChange}
              value={
                [searchParams.get("StartDate") ? dayjs(searchParams.get("StartDate"), "MM-DD-YYYY") : null,
                  searchParams.get("EndDate") ? dayjs(searchParams.get("EndDate"), "MM-DD-YYYY") : null]
              }
              format="MMM D, YYYY"
            />
          </div>}
        </div>
        {!detectMobile && <div className="userTypeCount">
          Showing {employers.length ? employers[0].TotalCount : 0} results
        </div>}
      </div>
      <EmployerFilter 
        profession={profession} 
        setProfession={setProfession}
        status={status}
        setStatus={setStatus}
        val={val} 
        setVal={setVal}
        privateEmployer={privateEmployer}
        setPrivateEmployer={setPrivateEmployer}
      />
      {detectMobile && <Col className="SearchHeader-Show-Results-section" span={24}>
        <span className="SearchHeader-Show-Results">
          Showing {employers.length ? employers[0].TotalCount : 0} results
        </span>
      </Col>}
      <div className="CommonTableContainer">
        {!detectMobile ? <EmployerTable /> : <EmployerCard />}
        <br />
        <Pagination
          showSizeChanger
          defaultPageSize={searchParams.get("limit") ? searchParams.get("limit") : 10}
          defaultCurrent={searchParams.get("page") ? searchParams.get("page") : 1}
          current={searchParams.get("page") ? searchParams.get("page") : 1}
          pageSize={searchParams.get("limit") ? searchParams.get("limit") : 10}
          onChange={handleChange}
          onShowSizeChange={onShowSizeChange}
          total={employers.length ? employers[0].TotalCount : 0}
        />
      </div>
    </div>
  );
}
